import { render, staticRenderFns } from "./product-scripts.vue?vue&type=template&id=f60fa40a&"
import script from "./product-scripts.vue?vue&type=script&lang=ts&"
export * from "./product-scripts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports